<div>
  <canvas #myCanvas id="drawCanvas"  [width]="canvasWidth" [height]="canvasHeight" [ngStyle]="{'border': '1px solid'}" class="responsive-canvas"></canvas>
  <br/>
  <ng-container *ngIf="isConfigSignDefault">
    <div class="d-flex justify-content-between my-3">
      <div class="d-flex align-items-center">
        <div class="mr-2" style="color: #121517; font-weight: 500;">{{'enterprise_contract.image_signing.no_image.color' | translate}}</div>
        <div [ngClass]="signaturePad?.penColor === '#EE0033' ? 'border-select' : ''">
          <div (click)="changeColorDrawCanvas('#EE0033')" style="background-color: #EE0033; width: 1.25rem; height: 1.25rem; border-radius: 50%; cursor: pointer;"></div>
        </div>
        <div [ngClass]="signaturePad?.penColor === '#0000ff' ? 'border-select' : ''" class="mr-2" class="mx-2">
          <div (click)="changeColorDrawCanvas('#0000ff')" style="background-color: #0000ff; width: 1.25rem; height: 1.25rem; border-radius: 50%; cursor: pointer;"></div>
        </div>
        <div [ngClass]="signaturePad?.penColor === '#121517' ? 'border-select' : ''" class="mr-2">
          <div (click)="changeColorDrawCanvas('#121517')" style="background-color: #121517; width: 1.25rem; height: 1.25rem; border-radius: 50%; cursor: pointer;"></div>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div class="mr-3" style="color: #121517; font-weight: 500;">{{'enterprise_contract.image_signing.no_image.eraser' | translate}}</div>
        <div [ngClass]="signaturePad?.minWidth === 2 && signaturePad?.maxWidth === 2 ? 'border-select' : ''">
          <div (click)="changeEraserDrawCanvas(2)" style="background-color: #121517; width: 0.25rem; height: 0.25rem; border-radius: 50%; cursor: pointer;"></div>
        </div>
        <div [ngClass]="signaturePad?.minWidth === 4 && signaturePad?.maxWidth === 4 ? 'border-select' : ''" class="mx-3">
          <div (click)="changeEraserDrawCanvas(4)" style="background-color: #121517; width: 0.375rem; height: 0.375rem; border-radius: 50%; cursor: pointer;"></div>
        </div>
        <div [ngClass]="signaturePad?.minWidth === 6 && signaturePad?.maxWidth === 6 ? 'border-select' : ''" class="mr-3">
          <div (click)="changeEraserDrawCanvas(6)" style="background-color: #121517; width: 0.5rem; height: 0.5rem; border-radius: 50%; cursor: pointer;"></div>
        </div>
        <div [ngClass]="signaturePad?.minWidth === 8 && signaturePad?.maxWidth === 8 ? 'border-select' : ''">
          <div (click)="changeEraserDrawCanvas(8)" style="background-color: #121517; width: 0.625rem; height: 0.625rem; border-radius: 50%; cursor: pointer;"></div>
        </div>
      </div>
    </div>
  </ng-container>
  <div id="bottom-toolbar" style="padding-bottom: 5px;" [ngStyle]="{'text-align': 'center'}">
    <button [disabled]="disableBtnDeleteCanvas" mat-stroked-button color="{{ isConfigSignDefault ? 'primary' : 'gray' }}" class="mr-3"
            (click)="clearCanvas()" type="button">
      <span class="material-icons">brush</span>{{'button.re_draw' | translate}}
    </button>
    <ng-container>
      <button [disabled]="disableBtnDeleteCanvas || disableBtnApplyCanvas" mat-raised-button color="primary" (click)="onSaveCanvas(true)"
              type="button">
        <svg style="margin-right: 0.5rem" width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.98705 9.09594L2.09539 6.20427C1.77039 5.87927 1.24539 5.87927 0.920386 6.20427C0.595386 6.52927 0.595386 7.05427 0.920386 7.37927L4.40372 10.8626C4.72872 11.1876 5.25372 11.1876 5.57872 10.8626L14.3954 2.04594C14.7204 1.72094 14.7204 1.19594 14.3954 0.87094C14.0704 0.54594 13.5454 0.54594 13.2204 0.87094L4.98705 9.09594Z" fill="white"/>
        </svg>
        {{'button.apply' | translate}}
      </button>
    </ng-container>
  </div>
</div>
